// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import 'rc-slider/assets/index.css'
import React from 'react'
import PropStyles from 'catena/er2_styles/layer_properties'

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    )
}

type PropTypes = {
    tableProps: {
        schema: {
            properties: {},
        },
    },
    onChangeProps: Function,
    onClose: Function,
    pos: {
        right: number,
        top: number,
    },
    theme: PropStyles,
}

const assignKeys = (tagList) => {
    for (let i = 0; i < tagList.length; i++) {
        tagList[i].key = i
    }
}

class TableProperties extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.symHTMLref = React.createRef()
        this.state = {
            author: '',
            editSym: -1,
            height: 0,
            newTag: '',
            tags: [],
            value: 0,
            ...props.tableProps,
        }
    }

    deleteTag(i) {
        const tags = [...this.state.tags]
        tags.splice(i, 1)
        this.setState({ tags })
    }

    hasTag(tag) {
        const tags = this.state.tags
        for (let i = 0; i < tags.length; i++) {
            if (tags[i].label === tag) return true
        }
        return false
    }

    addTag(label) {
        let tags = this.state.tags
        if (!this.hasTag(label) && label !== '') {
            tags = [...this.state.tags, { label: label.toLowerCase(), key: this.state.tags.length }]
            tags.sort((a, b) => {
                return a.label > b.label
            })
            assignKeys(tags)
            this.setState({ tags: tags })
        }
    }

    handleTagInput(input) {
        if (input.split(' ').length > 1) {
            let tagWord = input.split(' ')[0].toLowerCase()
            tagWord = tagWord.replace(/\W/g, '')
            this.addTag(tagWord)
            this.setState({ newTag: '' })
        } else {
            input = input.replace(/\W/g, '')
            this.setState({ newTag: input })
        }
    }

    render() {
        const value = this.state.value
        const handleChange = (event, value) => {
            this.setState({ value })
        }

        const tags = this.state.tags.map((data, i) => {
            return (
                <Chip
                    key={data}
                    label={data.label}
                    onDelete={() => this.deleteTag(i)}
                    className={this.theme.tag}
                />
            )
        })

        const boxPosition = {
            right: this.props.pos.right,
            top: ((this.props.pos.top + this.state.height < window.innerHeight - 2) ?
                this.props.pos.top : (window.innerHeight - 2 - this.state.height)),
        }

        return (
            <div
                ref={(el) => {
                    this.ref = el
                }}
                className={this.theme.boxTableProps}
                style={boxPosition}
                // Prevents drag and drop from blocking input
                //   (https://github.com/atlassian/react-beautiful-dnd#interactive-child-elements-within-a-draggable)
                onMouseDown={e => e.stopPropagation()}
            >
                <AppBar
                    position="static"
                    color="secondary"
                >
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Metadata" />
                    </Tabs>
                </AppBar>
                {value === 0 && (
                    <TabContainer>
                        <table className={this.theme.table}>
                            <tbody>
                                <tr>
                                    <td className={this.theme.paramLabel}>
                                        Author
                                    </td>
                                    <td>
                                        <TextField
                                            className={this.theme.inputStyle}
                                            type="text"
                                            defaultValue={this.state.author}
                                            onChange={e => {
                                                this.setState({ author: e.target.value })
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={this.theme.paramLabel}>
                                        Feature Count
                                    </td>
                                    <td className={this.theme.metadataItem}>
                                        {this.props.tableProps.row_count}
                                    </td>
                                </tr>
                                <tr>
                                    <td className={this.theme.paramLabel}>
                                        File Path
                                    </td>
                                    <td className={this.theme.metadataItem}>
                                        {this.props.tableProps.filepath}
                                    </td>
                                </tr>
                                <tr>
                                    <td className={this.theme.paramLabel}>
                                        Name
                                    </td>
                                    <td className={this.theme.metadataItem}>
                                        {this.props.tableProps.name}
                                    </td>
                                </tr>
                                <tr>
                                    <td className={this.theme.paramLabel}>
                                        Tags
                                    </td>
                                    <td>
                                        <TextField
                                            className={this.theme.inputStyle}
                                            type="text"
                                            value={this.state.newTag}
                                            onChange={e => {
                                                this.handleTagInput(e.target.value)
                                            }}
                                            onKeyDown={e => {
                                                if (e.keyCode == 13 && e.shiftKey == false) {
                                                    e.preventDefault()
                                                    this.handleTagInput(this.state.newTag + ' ')
                                                }
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                    </td>
                                    <td>
                                        <div className={this.theme.tagBox}>
                                            {tags}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </TabContainer>
                )}

                <Button
                    className={this.theme.closeButton}
                    onClick={() => this.props.onClose()}
                    variant="contained"

                >
                    Cancel
                </Button>
                <Button
                    className={this.theme.updateButton}
                    variant="contained"
                    onClick={() => this.props.onChangeProps(this.state)}
                >Update
                </Button>

            </div>
        )
    }
}

export default TableProperties
